import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { FaAngleDown, FaAngleUp, FaStar } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { Box, Button, Flex, Text, Textarea } from 'theme-ui';
import { IRatingCriteria, IUserRef, RootState } from '../../../../../@types';
import { createRating, getCriteriabyTaskId } from '../../../../store/actions/Rating.Action';
import CustomRating from '../../../CustomRating';
import { ReportHistory } from './ReportHistory/ReportHistory';
import theme from '../../../../theme';

interface ReviewProps {
    data: any;
    // type: 'worker' | 'task';
    type?: 'worker' | 'task' | 'taskWorker' | 'taskManager' | 'projectManager' | 'projectWorker';
    colorMode?: string,
}

const ReviewModal: React.FC<ReviewProps> = ({ data, type, colorMode }) => {
    const dispatch = useDispatch();
    const [open, setIsOpen] = useState(false);
    const { rating: RatingCriteria } = useSelector((state: any) => state.rating);
    const { dataForTable } = useSelector((state: RootState) => state.masterData);
    const [lastUpdatedTwoWeeksAgo, setlastUpdatedTwoWeeksAgo] = useState(false);
    const [rating, setRating] = useState<number[]>([1, 1, 1, 1]);
    const [comment, setComment] = useState<string[]>([]);
    const commentRefs = useRef<(HTMLTextAreaElement | null)[]>([]); // Array of refs for the textareas

    const { auther } = useSelector((state: RootState) => state.auth);
    const isUserActive = (user: IUserRef | string | null | undefined, listName: 'allProjectManagers' | 'allProjectWorkers' | 'allTaskManagers' | 'allTaskWorkers') => {
        if (!user) return false;
        const id = typeof user === 'string' ? user : user._id;
        if (!id) return false;
        return dataForTable?.data?.[listName]?.some((u: { _id: string }) => u._id === id);
    };

    const [showHistory, setShowHistory] = useState<boolean>(false);
    const handleRatingChange = (index: number, newRating: number) => {
        const updatedRatings = [...rating];
        updatedRatings[index] = newRating;
        setRating(updatedRatings);
    };

    const handleCommentChange = (index: number, event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const updatedComments = [...comment];
        updatedComments[index] = event.target.value;
        setComment(updatedComments);

        const textarea = commentRefs.current[index];
        if (textarea) {
            textarea.style.height = 'auto';
            textarea.style.height = textarea.scrollHeight + 'px';
        }
    };

    const handleOpen = () => {
        setIsOpen(true);
        dispatch(getCriteriabyTaskId(data?.taskId?._id || 'null'));
    };

    useEffect(() => {
        const todayDate = new Date();
        let days = moment(todayDate).diff(moment(RatingCriteria?.updatedAt), "days", false);

        if (days <= 14) {
            setlastUpdatedTwoWeeksAgo(true)
        } else {
            setlastUpdatedTwoWeeksAgo(false)
        }

    }, [RatingCriteria?.updatedAt]);

    const toggle = () => setIsOpen(!open);
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={toggle}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "secondary" : "#dadada";

    const handleSave = () => {
        const payload = {
            workerName: type === 'worker' ? data?.projectWorker?.FirstName : type === 'taskWorker' ? data?.worker?.FirstName : type === 'taskManager' ? data?.manager?.FirstName : data?.worker?.FirstName,
            workerNameRef: type === 'worker' ? data?.projectWorker?._id : type === 'taskWorker' ? data?.worker?._id : type === 'taskManager' ? data?.manager?._id : data?.worker?._id,
            // workerNameRef: type === 'worker' ? data?.projectWorker?._id : data?.worker?._id,
            ratingGivenBy: auther?.FirstName,
            ratingGivenByRef: auther?._id,
            projectName: data?.projectId?.name || data?.name,
            projectNameRef: data?.projectId?._id || data?._id,
            tradeName: data?.name,
            tradeNameRef: data?.taskId?._id,
            projectPhase: {
                value: data?.stageId?._id,
                label: data?.stageId?.temporaryName || data?.stageId?.name
            },
            criteria: RatingCriteria?.ratingCriteria?.map((ratingText: IRatingCriteria, index: number) => ({
                id: ratingText?._id,
                name: ratingText?.ratingCriteria,
                rating: rating[index] || 0,
                comment: comment[index]
            }))
        };
        dispatch(createRating(payload));
        setIsOpen(false);
        setComment([]);
    };

    return (
        <>
            {type === 'worker' && (() => {
                const user = data?.projectWorker;
                const active = isUserActive(user, 'allProjectWorkers');
                return active ? (
                    <Text>
                        {user?.FirstName} {user?.LastName}
                        {auther?.CanManageTo?.length > 0 && auther?.CanManageTo?.map((worker: { _id: string }, index: number) => (
                            worker?._id === user?._id ? <FaStar key={index} style={{ cursor: 'pointer' }} color="#FFB721" onClick={handleOpen} /> : null
                        ))}
                    </Text>
                ) : <Text></Text>;
            })()}
            {type === 'task' && (() => {
                const user = data?.worker;
                const active = isUserActive(user, 'allTaskWorkers');
                return active ? (
                    <Text>
                        {user?.FirstName} {user?.LastName}&nbsp;&nbsp;
                        {auther?.CanManageTo?.length > 0 && auther?.CanManageTo?.map((worker: { _id: string }, index: number) => (
                            worker?._id === user?._id ? <FaStar key={index} style={{ cursor: 'pointer' }} color="#FFB721" onClick={handleOpen} /> : null
                        ))}
                    </Text>
                ) : <Text></Text>;
            })()}
            {type === 'taskManager' && (() => {
                const user = data?.manager;
                const active = isUserActive(user, 'allTaskManagers');
                return active ? (
                    <Text>
                        {user?.FirstName} {user?.LastName}&nbsp;
                        {auther?.CanManageTo?.length > 0 && auther?.CanManageTo?.map((manager: { _id: string }, index: number) => (
                            manager?._id === user?._id ? <FaStar key={index} style={{ cursor: 'pointer' }} color="#FFB721" onClick={handleOpen} /> : null
                        ))}
                    </Text>
                ) : <Text></Text>;
            })()}

            {type === 'taskWorker' && (() => {
                const user = data?.worker;
                const active = isUserActive(user, 'allTaskWorkers');
                return active ? (
                    <Text>
                        {user?.FirstName} {user?.LastName}&nbsp;
                        {auther?.CanManageTo?.length > 0 && auther?.CanManageTo?.map((worker: { _id: string }, index: number) => (
                            worker?._id === user?._id ? <FaStar key={index} style={{ cursor: 'pointer' }} color="#FFB721" onClick={handleOpen} /> : null
                        ))}
                    </Text>
                ) : <Text></Text>;
            })()}

            <Modal toggle={toggle} isOpen={open} backdrop="static" size="xl" centered scrollable>
                <ModalHeader toggle={toggle} close={closeButton} style={{ backgroundColor: modalHeader, color: titleHeader }}>Rating Review</ModalHeader>
                <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                    <Row>
                        <Col sm={8} className='pe-0 pb-3'>
                            <Flex sx={{ justifyContent: 'space-between', flexDirection: "column", height: "100%" }}>
                                <ModalBody>
                                    {RatingCriteria?.ratingCriteria?.length > 0 && RatingCriteria?.ratingCriteria?.map((ratingText: IRatingCriteria, index: number) => {
                                        return (
                                            <div className="mb-4" key={index}>
                                                <h5> {ratingText?.ratingCriteria}</h5>
                                                <CustomRating count={5} onChange={(newRating: number) => handleRatingChange(index, newRating)} disabled={false} />
                                                <Textarea
                                                    className="form-control mt-2"
                                                    placeholder="enter comment here..."
                                                    value={comment[index] || ''}
                                                    rows={2}
                                                    onChange={(event) => handleCommentChange(index, event)}
                                                    ref={(el) => (commentRefs.current[index] = el)}
                                                    style={{ overflow: 'hidden' }}
                                                />
                                            </div>
                                        );
                                    })}
                                </ModalBody>
                                <ModalFooter className='gap-3'>
                                    <Button variant="CancelButton" onClick={toggle}>
                                        Cancel
                                    </Button>
                                    <Button variant="SaveButton" onClick={handleSave}>
                                        Save
                                    </Button>
                                    <Flex sx={{
                                        border: "1px solid #7743DB", borderRadius: "12px", mx: "1rem", padding: "14px", cursor: 'pointer', justifyContent: "space-between", alignItems: "center", width: "100%"
                                    }} onClick={() => setShowHistory(!showHistory)}><Text>History</Text>{showHistory ? <FaAngleUp className='text-end' /> : <FaAngleDown className='text-end' />}
                                    </Flex>
                                </ModalFooter>
                            </Flex>
                        </Col>
                        <Col sm={4} className='border-start p-4'>
                            Activity
                            <p style={{ color: colorMode === 'light' ? 'muted' : 'white' }}>All Activities</p>
                            <Box className='border p-2' sx={{ borderRadius: '12px', borderColor: `${theme?.colors?.lightbackground}` }}>
                                <p className='mb-0' style={{ color: colorMode === 'light' ? 'muted' : 'white' }}>Project Name :</p>
                                <Text sx={{ color: colorMode === 'light' ? 'muted' : 'white' }}>{type === 'worker' ? data?.name : data?.projectId?.name}</Text>
                            </Box>
                            <Box className='border p-2 mt-3' sx={{ borderRadius: '12px', borderColor: `${theme?.colors?.lightbackground}` }}>
                                <p className='mb-0' style={{ color: colorMode === 'light' ? 'muted' : 'white' }}>Task Name :</p>
                                <Text sx={{ color: colorMode === 'light' ? 'muted' : 'white' }}>{data?.name}</Text>
                            </Box>
                            <Box className='border p-2 my-3' sx={{ borderRadius: '12px', borderColor: `${theme?.colors?.lightbackground}` }}>
                                <p className='mb-0' style={{ color: colorMode === 'light' ? 'muted' : 'white' }}>Stage Name :</p>
                                <Text sx={{ color: colorMode === 'light' ? 'muted' : 'white' }}>{type === 'worker' ? (data?.stagesNameList?.[0]?.temporaryName || data?.stagesNameList?.[0]?.name) : (data?.stageId?.temporaryName || data?.stageId?.name)}</Text>
                            </Box>
                            <Box className='border p-2 ' sx={{ borderRadius: '12px', borderColor: `${theme?.colors?.lightbackground}` }}>
                                <p className='mb-0' style={{ color: colorMode === 'light' ? 'muted' : 'white' }}>Worker :</p>
                                <Text sx={{ color: colorMode === 'light' ? 'muted' : 'white' }}>{type === 'worker' ? data?.projectWorker?.FirstName : data?.worker?.FirstName}</Text>
                            </Box>
                            <Box className='border p-2 my-3' sx={{ borderRadius: '12px', borderColor: `${theme?.colors?.lightbackground}` }}>
                                <p className='mb-0' style={{ color: colorMode === 'light' ? 'muted' : 'white' }}>UpdatedAt :</p>
                                <Text sx={{ color: colorMode === 'light' ? 'muted' : 'white' }}>{moment(RatingCriteria?.updatedAt).format('DD MMM YYYY, h:mm A')}{lastUpdatedTwoWeeksAgo ? <Text sx={{ cursor: 'pointer' }}  >{" "}
                                    <FaStar color="#FFB721" />

                                </Text> : <Text sx={{ cursor: 'pointer' }}  >
                                    {" "}<FaStar color="#006D8F" />
                                </Text>}</Text>
                            </Box>
                        </Col>
                    </Row>
                    {showHistory && <ModalBody className='border-top'>
                        <h5>Rating Review</h5>
                        <ReportHistory tradeNameRef={data?.taskId?._id} showHistory={showHistory} />

                    </ModalBody>}
                </ModalBody>
            </Modal>
        </>
    );
};

export default ReviewModal;
